import { createFetch } from '@vueuse/core'
import { useCookies } from '@vueuse/integrations/useCookies'
import { i18n } from '@/main'

export const myCookies = useCookies(['sessionid', 'csrftoken'])

export const useMyFetch = createFetch({
  baseUrl: '/api/server/v1',
  options: {
    async beforeFetch({ options }) {
      options.headers = options?.headers ? new Headers(options.headers) : new Headers()
      options.headers.set('X-Csrftoken', myCookies.get('csrftoken'))
      options.headers.set('Accept-Language', i18n.global.locale.value)
      return { options }
    },
    async onFetchError(ctx) {
      if (ctx.data?.detail) {
        ctx.error = new Error(ctx.data.detail)
      }
      ctx.error.code = ctx.response?.status
      return ctx
    }
  },

  fetchOptions: {
    credentials: 'include'
  }
})
